import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addRecipe, getDiet, getAllRecipes } from "../actions";
import { Link, useHistory } from "react-router-dom";
import s from '../componentsStlyes/CreateRecipes.module.css'



export default function CreateRecipes(){
    const dispatch = useDispatch();
    const history = useHistory()
    const diets = useSelector((state) => state.diet);
    const recetas = useSelector((state) => state.recipes )
    
    const [error, setErrors]=useState({});
    const recipesNames = recetas.map(e => e.title)
    console.log('RecipesNames', recipesNames)
    function validate(input){
        let error = {}
        if(input.title.length >= 0 && !input.title.match(/^[a-zA-Z_]+( [a-zA-Z_]+)*$/)){
            error.title = 'Solo se permiten letras y sin espacios al final!'
        }else error.title = null
        if(input.image.length > 0 && !input.image.match(/^(ftp|http|https):\/\/[^ "]+$/)){
            error.image = 'La imagen tiene que ser un URL'
        }else error.image = null
        if(input.summary && input.summary.length > 30){
            error.summary = 'Tiene que contener máximo 30 caracteres'
        }else error.summary = null
        if(input.steps && input.steps.length > 1000){
            error.steps = 'Tiene que contener máximo 1000 caracteres'
        }else error.steps = null
        if(input.healthScore > 100 || input.healthScore < 0){
            error.healthScore = 'Tiene que ser entre 0 y 100'
        }else error.healthScore = null
        if(input.diets && input.diets.length === 0 && diets.includes(input.diet)){
            error.diets = 'Tienes que elegir al menos una dieta'
        }else error.diets = null
        return error
    }
// Guardo lo que me entra en el formulario en un estado
//Le paso por el useState un objeto con todo lo que necesita el post
    const [newRecipe, setNewRecipe] = useState({
      title: "",
      diets: [],
      image: "",
      healthScore: null,
      summary: "",
      steps: "",
    });
// El handleChange va a ir manejando cada vez que cambie o se modifiquen mis inputs
// Yo quiero ir guardando las cosas que el usuario va escribiendo en el input en mi estado newRecipe
//Cada vez que ejecute esta funcion, a mi estado newRecipe, agregale el target value de lo que este modificando
// HandleChange sin validations
    // function handleChange(e){
    //     setNewRecipe({
    //         ...newRecipe,
    //         [e.target.name] : e.target.value 
    //     })
    // }
// HandleChange Con validations

    function handleChange(e){
        setNewRecipe({
            ...newRecipe,
            [e.target.name]: e.target.value
        });setErrors(validate({
            ...newRecipe,
            [e.target.name]:e.target.value
        }));
    }

    function handleSelect(e){
        const existe= newRecipe.diets.includes(e.target.value)
        if(existe){
            alert('Esta dieta ya está incluida')
        }
        else{
            setNewRecipe({
                ...newRecipe,
                diets: [...newRecipe.diets, e.target.value] //Traeme lo que ya habia y concatename lo que hay en el value
            }); setErrors(validate({
                ...newRecipe,
                diets : [...newRecipe.diets,e.target.value]
        }))}
    }
    //


    useEffect( () => { //Acá le indicamos al componente lo que tiene que hacer luego de renderizarse
        dispatch(getDiet())
        dispatch(getAllRecipes())
    } , [dispatch])
    console.log('En el use Effect de createRecipes'+diets)



    function handleSubmit(e){
        e.preventDefault();
        if(recipesNames.includes(newRecipe.title)){

            alert('Ya existe esta receta!')
        }
        if(error.title === null && error.image === null && error.summary === null && error.steps === null
        && error.healthScore === null && error.steps === null && error.diets === null){
        dispatch(addRecipe(newRecipe))
        alert('Receta Creada!')
        setNewRecipe({
            title: "",
            diets: [],
            image: "",
            healthScore: null,
            summary: "",
            steps: "",
        })
        history.push('/Cards')
    }else{
        alert('Arregla los errores marcados y completa los espacios requeridos')
    }
    }

    function deleteSelect(id){
        setNewRecipe({
            ...newRecipe,
            diets : newRecipe.diets.filter(d=> d !== id)
        })
        // setErrors(validate({
        //     ...newRecipe,
        //     diets : [...newRecipe.diets.filter(d=> d !== id)]
        // }))
    }
    
    
    return(
        <div className={s.realFondo}>
            <div  className={s.fondo}>
                <Link to='/Cards'><button className={s.volver}>¡Menús!</button></Link>
                <h1 className={s.creaTuReceta}>Create your recipe</h1>
                <form className={s.form} onSubmit={handleSubmit}>
                    <div className={s.div}>
                        <label>Title: </label>
                        <input
                        className={s.inputs}
                        placeholder="Nombre de tu receta"
                        type='text'
                        value={newRecipe.title}
                        name='title'
                        onChange={handleChange}
                        />
                        {error.title&& (
                                <p className={s.errors}>{error.title}</p>
                            )}
                    </div>
                        
                    <div>
                        <label>Image: </label>
                        <input
                        className={s.inputs}
                        placeholder="Inserta una imagen!"
                        type='text'
                        value={newRecipe.image}
                        name='image'
                        onChange={handleChange}
                        />
                        {error.image&& (
                                <p className={s.errors} >{error.image}</p>
                            )}
                    </div>
                    <div>
                        <label>HealthScore: </label>
                        <input
                        className={s.inputs}
                        placeholder="¿Que tan saludable es?"
                        type='text'
                        value={newRecipe.healthScore}
                        name='healthScore'
                        onChange={handleChange}
                        />
                        {error.healthScore&& (
                                <p className={s.errors}>{error.healthScore}</p>
                            )}
                    </div>
                    <div>
                        <label>Recipe: </label>
                        <input
                        className={s.inputs}
                        placeholder="¡Ingredientes necesarios!"
                        type='text'
                        value={newRecipe.summary}
                        name='summary'
                        onChange={handleChange}
                        />
                        {
                            error.summary &&(
                                <p  className='error'>{error.summary}</p>
                            )
                        }
                    </div>
                    <div>
                        <label>Steps: </label>
                        <input
                        className={s.inputs}
                        placeholder="¡Explicá como se hace!"
                        type='text'
                        value={newRecipe.steps}
                        name='steps'
                        onChange={handleChange}
                        />
                    </div>
                        <p className={s.dietas}>Diets: </p>
                        <select className={s.dietas} onChange={(e) => handleSelect(e)}>
                            {
                            diets.map(d => (
                                <option value={d.name}>{d.name}</option>
                                ))}
                            
                        </select>
                        {
                            error.diets &&(
                                <p  className='error'>{error.diets}</p>
                                )
                                }
                                {
                                    
                                    newRecipe.diets.map(e=>
                                        <div className={s.div}>
                                            <div>
                                                <a type='text' className={s.botonEliminarDieta} onClick={()=> deleteSelect(e)}>X {e}</a>
                                            </div>
                                        </div>
                                        )
                                    
                                    }
                    <ul>
                        {/* <li>
                            {newRecipe.diets.map(e => e + ', ')}
                        </li> */}
                    </ul>
                    <button className={s.botonCrear} type="submit">Create</button>
                </form>
            </div>
        </div>
    )
    
}
 